/********************************************************************
* Created ON:27/12/2018
* Created by: Avaya
* Description: Common component for help guild lady.
* Revision History:
* Modification date:
* Description: T
**********************************************************************/
import { Component, OnInit, Input, SimpleChanges,Injectable } from '@angular/core';
import { NodeService } from '../../services/node.service';
import { StorageService } from '../../services/storage.service';
import { MuteService } from '../../services/mute.service';
declare var require: any;
@Injectable()

@Component({
  selector: 'app-help-guide',
  templateUrl: './help-guide.component.html',
  styleUrls: ['./help-guide.component.css']
})

export class HelpGuideComponent implements OnInit {
  /**
   * Input variable for audio, vtt file's url and class
   */
  @Input() audioUrl: string;
  @Input() textUrl: string;
  @Input() newClass: string;
  @Input() animatedCharecter: string;
  @Input() newClassDialogue: string;
  public hidePopOverClass = false;
  public allAudioTags;
  public popOverText: string = '';
  public popoverIcon = 'Show Text Box';
  public popoverIconFlag = 'Show';
  public popoverClass = 'a-popover';
  public hidePopOverFlag: boolean = false;
  constructor(private storageService: StorageService,
    private muteService: MuteService) { }

  ngOnInit() {
    this.muteService.muteFun();
    this.popOverText = "../../assets/img/chat-close.svg";
    let localStorageToken = this.storageService.getFromLocalStorage('loginToken');
    if (localStorageToken) {
      this.storageService.addToSessionStorage('loginToken', localStorageToken);
    }
   if( this.newClass == 'chat-icon-default'){
      this.hidePopOverClass = true;
      this.popOverText = "../../assets/img/chat-open.svg";
      this.popoverIcon = 'Hide Text Box';
      this.popoverIconFlag = 'Hide';
  }
    let loginToken = this.storageService.getFromSessioStorage('loginToken');
    if (loginToken) {
      this.popoverClass = 'a-popover-loggedIn';
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    var audioPlayer = <HTMLAudioElement>document.getElementById('audiofile');
    var subtitles = document.getElementById('subtitles');
    var syncData = []
    var rawSubTitle = "";
    var convertVttToJson = require('vtt-json');
    let that = this;

    audioPlayer.addEventListener("timeupdate", function (e) {
      fetch(new Request(that.textUrl))
        .then(response => response.text())
        .then(createSubtitle);
      syncData.forEach(function (element, index, array) {
        var el;
        if ((audioPlayer.currentTime * 1000) >= element.start && (audioPlayer.currentTime * 1000) <= element.end) {

          while (subtitles.hasChildNodes())
            subtitles.removeChild(subtitles.firstChild)

          el = document.createElement('span');
          el.setAttribute("id", "c_" + 0);
          el.innerText = syncData[index].part + "\n";
          el.style.background = 'yellow';
          subtitles.appendChild(el);
        }
      });

    });
    function createSubtitle(text) {
      var rawSubTitle = text;
      syncData = []
      convertVttToJson(text)
        .then((result) => { 
          var x = 0;
          for (var i = 0; i < result.length; i++) {
            if (result[i].part && result[i].part.trim() != '') {
              syncData[x] = result[i];
              x++;
            }
          }
        });
    }
  }
  public loadAudio(eleNo) {
    let profileAudio = <HTMLAudioElement>document.getElementById('audiofile');
    this.hidePopOverFlag = !this.hidePopOverFlag;
    if(eleNo == 99){
      profileAudio.src = "";
    }else{
        if (this.popoverIconFlag == 'Show') {
          profileAudio.src = '../../assets/audio/show_text_box.mp3'
        }
        if (this.popoverIconFlag == 'Hide') {
          profileAudio.src = '../../assets/audio/hide_text_box.mp3'
        }
    }
  }

  public hidePOpoverDialogue() {
    this.hidePopOverFlag = !this.hidePopOverFlag;
    if (!this.hidePopOverFlag) {
      this.popOverText = "../../assets/img/chat-close.svg";
      // this.audioUrl = "../../assets/audio/menu/Text_popover_Off.mp3";
      this.hidePopOverClass  = false;
      this.popoverIcon = 'Show text box';
      this.popoverIconFlag = 'Show';
      this.storageService.addToSessionStorage('hideText', true);
    }
    else {
      this.popOverText = "../../assets/img/chat-open.svg";
      this.hidePopOverClass  = true;
      this.popoverIcon = 'Hide text box';
      this.popoverIconFlag = 'Hide'
      // this.audioUrl = "../../assets/audio/menu/Text_popover_On.mp3"
      this.storageService.removeFromSessionStorage('ShowText');
    }
  }
  public mediaLoaded() {
    var audioPlayer = <HTMLAudioElement>document.getElementById('audiofile');
    audioPlayer.play();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component/help-guide/help-guide.component.ts